import { useModalStatusMessage } from '@/hooks';
import { useMutation } from '@apollo/client';
import { t } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { useCallback } from 'react';
import { REQUEST_GATE_MOVEMENT } from '../graphql/mutations/requestGateMovement';
import { RequestGateMovementMutation } from '@/__generated__/graphql';

interface UseMoveGateInput {
  onCompleted?: (data: RequestGateMovementMutation) => void;
}

export const useMoveGate = (input: UseMoveGateInput) => {
  const { i18n } = useLingui();
  const { openModalErrorMessage } = useModalStatusMessage();
  const [mutate, { loading }] = useMutation(REQUEST_GATE_MOVEMENT);

  const moveGate = useCallback(
    (gateId: string, position: number) => {
      mutate({
        variables: {
          input: {
            gateId,
            position,
          },
        },
        onCompleted(data) {
          // openModalSuccessMessage(t(i18n)`Se ha enviado la solicitud para mover la compuerta`);
          if (input.onCompleted) {
            input.onCompleted(data);
          }
        },
        onError(error) {
          openModalErrorMessage(t(i18n)`Hubo un error al enviar la solicitud`);
          console.error(error.message);
        },
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [mutate, i18n],
  );

  return { moveGate, loading };
};
